

























import { Vue, Component, Prop } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";
import defaultChartOptions from "@/models/defaultChartOptions";
import { organisationModule } from "@/store/modules/organisation";
import Helper from "../../utils/helper";
import { ApexOptions } from "apexcharts";
import _ from "lodash";

@Component({
  components: {
    apexchart: VueApexCharts,
  },
})
export default class YearlyChart extends Vue {
  // Props
  @Prop({ default: "350" }) readonly chartHeight!: string;
  @Prop({ default: "Utsläpp per år" }) readonly chartTitle!: string;
  @Prop({ default: "left" }) readonly chartTitleAlign!:
    | "left"
    | "center"
    | "right";

  public get organisation() {
    return organisationModule;
  }

  public get options() {
    const options: ApexOptions = {
      plotOptions: {
        bar: {
          distributed: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        formatter: (value) => {
          return value + " ton";
        },
      },
      tooltip: {
        y: {
          formatter: (value) => {
            return value + " ton CO<sub>2</sub";
          },
        },
      },
      yaxis: {
        title: {
          text: "CO\u2082 (kg)",
        },
      },
      xaxis: {
        categories: this.organisation.getCo2PerYear.map((x) => x.year),
      },
      title: {
        align: this.chartTitleAlign,
        text: this.chartTitle,
      },
    };

    return _.merge({}, defaultChartOptions, options);
  }

  public get series() {
    const series = [
      {
        name: "Totalt",
        data: this.organisation.getCo2PerYear.map((x) =>
          Helper.round(x.co2 / 1000)
        ),
      },
    ];
    return series;
  }
}
